const getApiUrl = () => {
    if (process.env.REACT_APP_API_URL) return process.env.REACT_APP_API_URL.replace(/\/$/, '');
    if (process.env.NODE_ENV === 'production') {
        return 'https://api.x4tech.org';
    }
    return 'http://localhost:8000';
};

const getFrontendUrls = () => {
    if (process.env.NODE_ENV === 'production') {
        return [
            'https://www.x4tech.org',  // Changed order to make x4tech.org primary
            'https://black-tree-07a3f960f.4.azurestaticapps.net'
        ];
    }
    return ['http://localhost:3000'];
};

const getGoogleClientId = () => {
    return process.env.REACT_APP_GOOGLE_CLIENT_ID || '';
};

export const config = {
    API_URL: getApiUrl(),
    FRONTEND_URLS: getFrontendUrls(),
    FRONTEND_URL: getFrontendUrls()[0],  // This will now be x4tech.org in production
    META_APP_ID: '1134270172042239',
    GOOGLE_CLIENT_ID: getGoogleClientId(),
};

/** Keep the legacy production app hostname on the same site as its session API.
 * Local builds and PR previews retain their own origins. Preserve one-time links.
 */
export const canonicalAppUrl = (): string | undefined => {
    if (process.env.NODE_ENV !== 'production' || window.location.origin !== 'https://black-tree-07a3f960f.4.azurestaticapps.net') return undefined;
    return `${config.FRONTEND_URL}${window.location.pathname}${window.location.search}${window.location.hash}`;
};
